import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {  TitleCasePipe } from '@angular/common';
import { FormGroup, ReactiveFormsModule, FormsModule, FormGroupDirective, ControlContainer } from '@angular/forms';
import { Subject } from 'rxjs';

import { User } from '../interfaces/user';

@Component({
  selector: 'app-birthdate-input',
  standalone: true,
  imports: [TitleCasePipe, ReactiveFormsModule, FormsModule],
  templateUrl: './birthdate-input.component.html',
  styleUrl: './birthdate-input.component.scss',
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class BirthdateInputComponent implements OnInit, OnDestroy {
  @Input() formGroupName!: string
  @Input() user!: User
  @Input() birthdateFormGroup!: string

  days: string[] = []
  months: {label: string, id: string}[] = [
    {
      label: $localize `:@@JANUARY:january`, 
      id: '01'
    }, 
    {
      label: $localize `:@@FEBRUARY:february`, 
      id: '02'
    }, 
    {
      label: $localize `:@@MARCH:march`, 
      id: '03'
    }, 
    {
      label: $localize `:@@APRIL:april`, 
      id: '04'
    }, 
    {
      label: $localize `:@@MAY:may`, 
      id: '05'
    }, 
    {
      label: $localize `:@@JUNE:june`, 
      id: '06'
    }, 
    {
      label: $localize `:@@JULY:july`, 
      id: '07'
    }, 
    {
      label: $localize `:@@AUGUST:august`, 
      id: '08'
    }, 
    {
      label: $localize `:@@SEPTEMBER:september`, 
      id: '09'
    }, 
    {
      label: $localize `:@@OCTOBER:october`, 
      id: '10'
    }, 
    {
      label: $localize `:@@NOVEMBER:november`, 
      id: '11'
    }, 
    {
      label: $localize `:@@DECEMBER:december`, 
      id: '12'
    }
  ]
  years: number[] = []
  youngestYear!: number
  oldestYear!: number
  loading = false
  birthdate: {day: string, month: string, year: string} = {day: '', month: '', year: ''}
  openDialog = false
  errorTitle: string = ''
  errorMessage: string = ''
  childForm!: FormGroup
  birthdateForm!: FormGroup
  private readonly _destroyed = new Subject<void>()

  constructor(
    private parentForm: FormGroupDirective
  ){
    // add days
    for(let i = 1; i <= 31; i++){
      const stringNumber = this.zeroPad(i, 2)
      this.days.push(stringNumber)
    }

    // add years, the most recent being today's year -18
    this.youngestYear = new Date().getFullYear() - 18
    this.oldestYear = new Date().getFullYear() - 99
    for(let i = this.youngestYear; i >= this.oldestYear; i--){
      this.years.push(i)
    }
  }

  zeroPad(num: number, places: number): string {
    return String(num).padStart(places, '0')
  }

  ngOnInit(){
    this.childForm = this.parentForm.form
    console.log(this.parentForm.control)
    // initialise form
    this.childForm = this.parentForm.control.get(this.formGroupName) as FormGroup
  }

  onClick(event: Event){
    event.stopPropagation()
  }

  ngOnDestroy(){
    this._destroyed.next()
    this._destroyed.complete()
  }
}
